import axios, { AxiosRequestConfig } from 'axios'
export function initAxios(config: AxiosRequestConfig) {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
  return {
    commService: axios.create(config),
    aggService: axios.create(config),
  }
}
